import { Popup } from 'maplibre-gl';
import { convertLatLngToLngLatLike, convertLngLatToLatLng } from '../convert.js';
import { MaplibreToggleEvent } from '../events/toggle.js';
import { add } from '../utils.js';
import { MaplibreObject } from './base.js';
export class MaplibrePopup extends MaplibreObject {
    #popup;
    #offset;
    #className;
    constructor(id, popup, offset, className) {
        super('PopupObject', id);
        this.#popup = popup;
        this.#offset = offset;
        this.#className = className;
    }
    get attached() {
        return !!this.#popup;
    }
    remove() {
        if (!this.#popup)
            return;
        this.#popup.remove();
        this.#popup = null;
    }
    get offset() {
        return this.#offset;
    }
    setOffset(offset) {
        if (!this.#popup)
            return;
        this.#popup.setOffset(offset);
        this.#offset = offset;
    }
    get pos() {
        if (!this.#popup)
            return [0, 0];
        return convertLngLatToLatLng(this.#popup.getLngLat());
    }
    setPos(pos) {
        if (!this.#popup)
            return;
        this.#popup.setLngLat(convertLatLngToLngLatLike(pos));
    }
    get className() {
        if (!this.#popup)
            return '';
        return this.#className;
    }
    setClassName(className) {
        if (!this.#popup)
            return;
        this.#popup.removeClassName(this.#className);
        this.#popup.addClassName(className);
    }
    get element() {
        if (!this.#popup)
            return null;
        return this.#popup.getElement();
    }
    onEvent(event, callback) {
        const popup = this.#popup;
        if (!popup)
            return () => { };
        const handler = MaplibreToggleEvent.convert(callback);
        popup.on(event, handler);
        return () => {
            popup.off(event, handler);
        };
    }
}
export const addPopup = add('popup', (map, options, id) => {
    if (map._removed)
        throw new Error('Map is removed');
    const popup = new Popup({
        offset: options.offset ?? 5,
        closeButton: false,
        anchor: options.anchor,
        className: options.className,
        closeOnClick: !options.permanent,
        closeOnMove: !options.permanent,
    });
    popup.setDOMContent(options.element);
    popup.setLngLat(convertLatLngToLngLatLike(options.pos));
    popup.addTo(map);
    return new MaplibrePopup(id, popup, options.offset ?? 5, options.className ?? '');
});
//# sourceMappingURL=data:application/json;base64,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